import { render, staticRenderFns } from "./updateNotesPop.vue?vue&type=template&id=2c8b7b41"
import script from "./updateNotesPop.vue?vue&type=script&lang=js"
export * from "./updateNotesPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports